// Shared contract for dashboard layout types and the card-id registry.
//
// CARD_IDS MUST stay in sync with the backend allowlist in
// `api/schemas/preferences.schemas.ts` (CARD_IDS).
export const CARD_IDS = [
  'morning-brief',
  'visual-site-overview',
  'workforce',
  'project-progress',
  'master-schedule',
  'activities',
  'safety',
  'delivery',
  'weather',
  'ai-agent',
] as const;

export type CardId = (typeof CARD_IDS)[number];

export type DashboardLayoutItem = {
  i: CardId;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
  /**
   * true = the card keeps its slot in the layout but is not rendered. Absent
   * means shown, so a card added in a later release arrives visible.
   *
   * The slot is deliberately kept rather than dropping the item: `hidden` is
   * how a saved layout expresses "not in this view", whereas a MISSING item
   * means "card the user has never seen" and `mergeWithDefault` restores it at
   * its default slot. Keeping x/y/w/h also puts the card back where it was
   * when it is turned on again.
   */
  hidden?: boolean;
};
